import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store";
import { ISettings } from "types/store/settings";
import { ICareerTab } from "types/store/careerTab";

const initialState: ISettings = {
  // language: "he",
  // dir: "rtl",
  // title: "עב",
  language: "en",
  dir: "ltr",
  title: "EN",
  isLoading: false,
  languages: [
    {
      lang: "en",
      dir: "ltr",
      title: "EN",
    },
    {
      lang: "he",
      dir: "rtl",
      title: "עב",
    },
  ],
  tenant: null,
};

const initialStateCareerTabSlice: ICareerTab = {
  sliderClickedArray: [],
  activeCareer: null,
  activeCareersSliders: null,
  occupations: [],
};


export const defaultSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setLanguage: (state, { payload }) => {
      state.language = payload.lang;
      state.dir = payload.dir;
      state.title = payload.title;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setTenant: (state, { payload }) => {
      state.tenant = payload;
    }
  },
});

export const careerTabSlice = createSlice({
  name: "careerTab",
  initialState: initialStateCareerTabSlice,
  reducers: {
    setActiveCareer: (state, { payload }) => {
      state.activeCareer = payload;
    },
    setActiveCareerSuggestions: (state, { payload }) => {
      if (state.activeCareer)
        state.activeCareer.next_careers = payload;
    },
    setActiveCareersSliders: (state, { payload }) => {
      state.activeCareersSliders = payload;
    },
    setOccupations: (state, { payload }) => {
      state.occupations = payload;
    }
  },
});

export const getSettings = (state: RootState) => state.settings;
export const getCareerTabData = (state: RootState) => state.careerTab;

export const { setLanguage, setLoading, setTenant } = defaultSlice.actions;
export const { setActiveCareer, setActiveCareersSliders, setActiveCareerSuggestions, setOccupations } = careerTabSlice.actions;

